// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5239b1ba","455":"996fc655","952":"d6afe0fc","977":"c1238de4"}[chunkId] + ".chunk.js";
};